import { cn } from '@/lib/utils'

export type HighlightColor = 'blue' | 'pink' | 'purple'

const HIGHLIGHT_BG: Record<HighlightColor, string> = {
  blue: 'var(--color-landing-accent)',
  pink: '#ff00f2',
  purple: 'var(--color-landing-secondary)',
}

/**
 * Inline highlight box for display headings (white text on a solid brand
 * block, rotated like `.landing-highlight`). Adds the pink variant the
 * global class does not ship.
 */
export function Highlight({
  color = 'blue',
  className,
  children,
}: {
  color?: HighlightColor
  className?: string
  children: React.ReactNode
}) {
  return (
    <span className={cn('landing-highlight', className)} style={{ background: HIGHLIGHT_BG[color] }}>
      {children}
    </span>
  )
}

/** Brand backdrop colours for tiles, in a fixed rotation. */
export const TILE_COLORS = ['var(--color-landing-accent)', '#ff00f2', 'var(--color-landing-secondary)'] as const

/** White halftone dots that thicken toward one side of a coloured tile. */
export const HALFTONE_STYLE: React.CSSProperties = {
  backgroundImage: 'radial-gradient(circle, rgb(255 255 255 / 0.55) 1.1px, transparent 1.6px)',
  backgroundSize: '9px 9px',
  maskImage: 'linear-gradient(to left, #000 0%, transparent 75%)',
  WebkitMaskImage: 'linear-gradient(to left, #000 0%, transparent 75%)',
}
